import styled from '@emotion/styled'
import { Box } from 'stylewhere/components'

interface Props {
  text: string
}

export const LabelTag = ({ text }: Props) => {
  return <Tag>{text}</Tag>
}

const Tag = styled(Box)`
  margin-inline-end: 0;
  margin-bottom: 0;
  background-color: #f5f5f5;
  border-color: #c8c7cc;
  border-width: 1px;
  border-style: solid;
  border-radius: 6px;
  color: #353535;
  font-size: 13px;
  line-height: 20px;
  padding-inline: 10px;
  padding-block: 4px;
`
